import React from 'react';
import './About.css'
import ralphImg from '../../assets/images/RBL8-1-Nov2020.jpg'
import SideBar from '../../components/SideBar/SideBar';

interface AboutProps {
  // Define props here
}

const About: React.FC<AboutProps> = () => {
  return (
    <div className="page-container">

      <div className="author-container">
        <div className="author-header">
          <img
            src={ralphImg} // update path as needed
            alt="Ralph Lloyd"
            className="author-photo"
          />
          <div className="author-bio">
            <h1>About the Author</h1>
            <p>
              Ralph Lloyd has been a believer in Jesus for nearly 40 years and as a layperson has served as a church elder,
              adult and youth Sunday school teacher, and non-profit organization board member. His passion is to help
              facilitate the spiritual growth and physical well-being of believers in Jesus and seekers of Jesus and build
              them up in any way possible.
            </p>
            <p>
              After working as an engineer in a major international corporation for over thirty years, he has started his
              own company and is now actively developing new technologies to help save lives and reduce global pollution,
              including new innovations to help combat COVID-19 and reduce Hospital Acquired Infections.
            </p>
            <p>
              Lately, he has been enjoying learning how to better “Seek the Lord and His strength; seek His face continually”
              (<strong>Psalm 105:4</strong>), including learning how to spend all night in prayer.
            </p>
            <p>
              Having helped raise eight children with his loving wife, he and most of his immediate family reside in North Carolina, USA.
            </p>
          </div>
        </div>
      </div>
      <div className="sidebar">
        <SideBar />
      </div>
    </div>
  );
};

export default About;
